import { useState, useContext, useEffect } from "react"
import { ProgressSpinner } from "primereact/progressspinner"
import _ from "lodash"
import { Avatar } from 'primereact/avatar';
import { Button } from 'primereact/button';
import { classNames } from 'primereact/utils';
import { useFormikContext } from "formik";
import styles from "../styles/Form-Inputs.module.css"

// Context
import { UserContext } from "../context/userContext"
import { FirebaseContext } from "../firebase"

export default function ProfileAvatar({ nameInitials, showRemovebtn }) {
  const userCtx = useContext(UserContext)
  const firebase = useContext(FirebaseContext)
  const [loading, setLoading] = useState(false)
  const [profileImageUrl, setProfileImageUrl] = useState("")
  const { values: formikValues, setFieldValue } = useFormikContext();
  const participantProfileImage = formikValues.participant_profile_image;

  const handleRemoveImage = () => {
    setFieldValue("participant_profile_image", "")
  };


  useEffect(() => {
    setLoading(true)

    const profileImage =
      participantProfileImage !== undefined
        ? participantProfileImage
        : userCtx.participant_profile_image

    const getProfileImageUrl = async () => {
      const { getStorage, ref, getDownloadURL } = firebase.storage
      const storage = getStorage()

      if (!_.isEmpty(profileImage)) {
        const logoRef = ref(storage, profileImage)
        return await getDownloadURL(logoRef)
      }

      return null
    }

    const fetchProfilePicture = async () => {
      const imageUrl = await getProfileImageUrl()
      setProfileImageUrl(imageUrl)
      setLoading(false)
    }

    fetchProfilePicture()
  }, [
    firebase.storage,
    userCtx.participant_profile_image,
    participantProfileImage,
    nameInitials
  ])

  if (loading) {
    return (
      <ProgressSpinner
        style={{ width: "50px", height: "50px" }}
        strokeWidth="4"
        animationDuration=".4s"
      />
    )
  }

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      <Avatar
        image={!_.isEmpty(profileImageUrl) ? profileImageUrl : null}
        label={_.isEmpty(profileImageUrl) ? nameInitials : null}
        shape="circle"
        style={{
          width: "50px",
          height: "50px",
          minWidth: "50px",
          background: "rgba(222, 190, 237, 0.5)",
          fontSize: "15px",
          color: "#873CAA",
          fontWeight: "500"
        }}
      />
      {showRemovebtn && !_.isEmpty(profileImageUrl) &&
        <Button
          icon="pi pi-times"
          type="button"
          className={classNames(styles.remove_pic_btn, "p-button-rounded")}
          onClick={handleRemoveImage}
          tooltip="Remove photo"
          tooltipOptions={{ position: "top", className: "custom-tooltip" }}
        />
      }
    </div>
  )

}
